import React from 'react';
import {
  Box,
  CircularProgress,
  Typography,
  Alert,
} from '@mui/material';
import SaveCardForm from './save-card-form';
import { useGetQuoteInfoByTokenQuery } from 'src/store/Reducer/job-types';
import Iconify from 'src/components/iconify';

export default function QuotePaymentView() {
  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get('token');

  const { data: quoteInfo, isLoading } = useGetQuoteInfoByTokenQuery(token);

  const handleCardSaved = (setupIntent) => {
    console.log('Card saved - setup intent:', setupIntent);
  };

  if (isLoading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.default',
          px: 2,
          py: 4,
        }} 
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        px: 2,
        py: 4,
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 480 }}>
        {/* Page heading */}
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Typography
            variant="caption"
            sx={{
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              color: 'text.disabled',
              display: 'block',
              mb: 0.5,
            }}
          >
            Quote #{quoteInfo?.quote_id}
          </Typography>
          <Typography variant="h5" fontWeight={600}>
            Secure Payment Setup
          </Typography>
          <Typography variant="body2" color="text.secondary" mt={0.5}>
            Add a card to enable fast payments on future invoices
          </Typography>
        </Box>

        {quoteInfo?.client?.tilled_payment_method_id && quoteInfo?.client?.is_card_saved ? (
          <Alert severity="info" icon={<Iconify icon="mdi:information-outline" />} sx={{ mt: 2 }}>
            This customer already has a saved payment method . You can proceed - the card will be
            charged automatically when an invoice is processed.
          </Alert>
        ) : (
          <SaveCardForm
            onSuccess={handleCardSaved}
            merchant_account_id={quoteInfo?.merchant_account?.tilled_account_id}
            customer_id={quoteInfo?.customer_id}
            client={quoteInfo?.client}
            quoteId={quoteInfo?.quote_id}
            isCardSaveRequired
          />
        )}
      </Box>
    </Box>
  );
}
